import React from 'react';
import { Users, Brain, Target, Heart } from 'lucide-react';
import { whyChooseUs } from '../data/mock';

const WhyChooseUs = () => {
  const iconMap = {
    "Users": Users,
    "Brain": Brain,
    "Target": Target,
    "Heart": Heart
  };

  return (
    <section className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-lime-100 rounded-full mb-4">
            <span className="text-lime-700 font-semibold text-sm">Why Choose Us</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {whyChooseUs.title}
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            {whyChooseUs.subtitle}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {whyChooseUs.principles.map((principle, index) => {
            const IconComponent = iconMap[principle.icon];
            return (
              <div
                key={index}
                className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-3 border border-gray-100 group relative overflow-hidden"
              >
                {/* Decorative gradient background */}
                <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-cyan-100 to-lime-100 rounded-full blur-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                
                <div className="relative z-10">
                  <div className="mb-6 p-4 bg-gradient-to-br from-cyan-500 to-lime-500 rounded-xl inline-block group-hover:scale-110 transition-transform duration-300">
                    {IconComponent && <IconComponent className="text-white" size={32} />}
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">
                    {principle.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {principle.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        {/* Additional Info */}
        <div className="mt-16 bg-gradient-to-r from-cyan-600 to-lime-600 rounded-2xl p-8 md:p-12 text-center text-white shadow-2xl">
          <h3 className="text-3xl md:text-4xl font-bold mb-4">
            Partnership That Delivers Results
          </h3>
          <p className="text-lg md:text-xl mb-6 max-w-3xl mx-auto opacity-95">
            We don't just provide services – we build lasting partnerships focused on your success. 
            Our team is dedicated to understanding your unique challenges and delivering solutions that truly make a difference.
          </p>
          <div className="flex flex-wrap justify-center gap-8 mt-8">
            <div>
              <div className="text-4xl font-bold mb-1">100%</div>
              <div className="text-cyan-100">Client Satisfaction Goal</div>
            </div>
            <div>
              <div className="text-4xl font-bold mb-1">8+</div>
              <div className="text-cyan-100">Industry Verticals</div>
            </div>
            <div>
              <div className="text-4xl font-bold mb-1">24/7</div>
              <div className="text-cyan-100">Support Available</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
